<template>
  <section class="pd-y-10">
    <!-- style="max-width: 600px !important" -->
    <div class="container" style="padding-bottom: 0px; padding-top: 20px;">
      <div class="section-title" style="text-align:left;">
        <h2>{{ comp.task }}</h2>
        <!-- <p class="mg-b-0">{{comp.f1}}</p> -->
      </div>
    </div>
    <div class="container mg-b-10" style="padding-top: 0px;">
      <div class="row">
        <!-- <div role="button" class="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
          <div class="card bg-dark ht-150 overflow-hidden" style="border-radius: 10px; background-color: #13407a !important;">
            <a @click="mdlSurvey= true" href="javascript:void(0)" class="">
              <div class="card-img-overlay d-flex align-items-center text-center">
                <div class="wd-100p">
                  <h4 class="text-white lh-1 text-truncate-2">Сургалтын хэрэгцээг тодорхойлох судалгаа</h4>
                  <p class="card-text text-white">[ Дэлгэрэнгүй ]</p>
                </div>
              </div>
            </a>
          </div>
        </div> -->

        <div
          class="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-2"
          v-for="(c, i) in types"
          :key="i"
          role="button"
        >
          <div class="card bg-dark ht-150 overflow-hidden" style="border-radius: 10px;">
            <a href="javascript:void(0)" @click="goToCourse(c.year)">
              <img
                class="card-img-top op-1"
                src="assets/img/course-type.jpg"
              />
              <div
                class="card-img-overlay d-flex align-items-center text-center"
              >
                <div class="wd-100p">
                  <div class="text-white lh-1 text-truncate-2 tx-bold" style="font-size: 24px;">{{ c.year }}</div>
                  <p class="card-text text-white">
                    Нийт {{ c.totalCount }} хичээл
                  </p>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="yrObj.mdl" fullscreen size="xl" title="Сургалтууд" scrollable hide-footer>
      <table class="table table-hover table-bordered">
        <thead>
          <tr>
            <th scope="col">Д/д</th>
            <th scope="col">Сургалтын нэр</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(t, i) in yrObj.list">
            <tr v-if="isDrawGroupDateRange(i)">
              <td class="bg-gray-50 text-muted" colspan="4">{{ t.locTypeName }}</td>
            </tr>
            <tr @click="$emit('on-course-info', t)" role="button">
              <th scope="row">{{ i+1 }}</th>
              <td>
                <div class="d-flex align-items-center tx-semibold">
                  <img :alt="t.task" :title="t.task" :src="`${t.defaultAttachmentUrl}?w=40&h=25&mode=crop`" class="mg-r-5 rounded-5" />
                  {{ t.task }}
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </b-modal>
  </section>
</template>

<script>
import { request } from "@/api/all";

export default {
  props: {
    comp: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      mdlSurvey: false,
      types: [],
      yrObj:{
        mdl: false,
        list: null
      },
    };
  },
  mounted() {
    this.loadTypes();
  },
  methods: {
    isDrawGroupDateRange(i) {
      let _fname = "locTypeName";
      if (i == 0) {
        return true;
      } else if (this.yrObj.list[i][_fname] != this.yrObj.list[i - 1][_fname]) {
        return true;
      } else {
        return false;
      }
    },
    goToCourse(yr){
      request({
        api: { method: "GET", url: "v2/learn/publicCourseListByYear" },
        params: {
          year: yr
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          // console.log('v2/learn/publicCourseListByYear=> ', res);
          this.yrObj.list = res.data.list;
          this.yrObj.mdl = true;
        }
      });
    },
    loadTypes() {
      request({
        api: { method: "GET", url: "v2/learn/publicCourseCountByYear" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.types = res.data.list;
          // if (res.data.types.length > 12) {
          //   this.types = res.data.types.filter(x => x.courseCount > 0);
          // }
          // console.log('type/getData=> ', res);
        }
      });
    }
  }
};
</script>

<style>
.text-truncate-2 {
  font-weight: 500;
  overflow:hidden;
  text-overflow:ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  min-height: 55px;
  max-height: 55px;
  margin-bottom: 10px;
  font-size: 16px;
}
</style>
